export default "__VITE_ASSET__CZeNPIAl__"